import React from 'react';

import {useDispatch, useSelector} from 'react-redux';

import {applicationsCountSelector} from 'features/applications/selectors';
import {deleteAllApplications} from 'features/applications/reducers/recordsSlice';

import {ActionsControl} from './ActionsControl';

export const ApplicationsControl = () => {
    const dispatch = useDispatch();

    const applicationsCount = useSelector((state) =>
        applicationsCountSelector(state)
    );

    return (
        <ActionsControl
            label="Return-To Applications"
            resourceCount={applicationsCount}
            onClickHandler={() => dispatch(deleteAllApplications())}
        />
    );
};
